import { get } from "../../../infra/rest";

interface LifetimePayoutResponse {
  data: {
    url: string | null;
  };
}

const getPayoutLifetimeDataAPI = async (
) => {
  const url = '/v1/channel-partner/payouts-lifetime-data';
  const response = await get<LifetimePayoutResponse>(url, {}, true);
  
  if (response.data?.url) {
    const link = document.createElement('a');
    link.href = response.data.url;
    const urlParts = response.data.url.split('/');
    const fileName = urlParts[urlParts.length - 1].split('?')[0];
    link.download = fileName;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

export default getPayoutLifetimeDataAPI;
